import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SanityImage from 'gatsby-plugin-sanity-image';

const StyledImage = styled(SanityImage)`
  display: block;
`;

function FrontMatterImage({ value }) {
  return (
    <StyledImage
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...value}
      width={value.asset.width}
      height={value.asset.height}
      size={value.asset.size}
    />
  );
}

FrontMatterImage.propTypes = {
  value: PropTypes.shape({
    asset: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      size: PropTypes.number,
    }),
    crop: PropTypes.arrayOf(PropTypes.shape({})),
    hotspot: PropTypes.arrayOf(PropTypes.shape({})),
    alt: PropTypes.string,
  }).isRequired,
};

export default FrontMatterImage;
